<template>
  <!-- options 自定义数据状态 -->
  <div>
    <span style="float: left; margin-right: 14px">{{ dict.name }}</span>
    <span v-if="dict.statusName" style="float: right; color: #8492a6; font-size: 12px">
      {{ dict.statusName }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    dict: {
      type: Object,
      default: null
    }
  },
}
</script>

<style lang="less">
</style>